export default "__VITE_ASSET__Co8lLQ5V__"